module.exports = __webpack_public_path__ + "c5562cfb1cf9aa02f35623d6de203692.png";